import { ServiceBase } from '../../../../core/services/ServiceBase'
import NotificationsProxy from '../proxies/NotificationsProxy'

class NotificationsService extends ServiceBase {
  getUserNotificationSettings(params) {
    return this.getData(() =>
      NotificationsProxy.getUserNotificationSettings(params),
    )
  }

  postUserNotificationSettings(params) {
    return this.getData(
      () => NotificationsProxy.postUserNotificationSettings(params),
      true,
    )
  }

  getUnreadCount(params) {
    return this.getData(() => NotificationsProxy.getUnreadCount(params))
  }

  getPaged(params) {
    return this.getData(() => NotificationsProxy.getPaged(params))
  }

  updateReadStatus(params) {
    return this.getData(() => NotificationsProxy.updateReadStatus(params), true)
  }

  postMarkAllAsRead(params) {
    return this.getData(
      () => NotificationsProxy.postMarkAllAsRead(params),
      true,
    )
  }

  deleteNotifications(params) {
    return this.getData(
      () => NotificationsProxy.deleteNotifications(params),
      true,
    )
  }
}

export default new NotificationsService()
